<template>
  <div class="stepper">
    <naj-button
      v-for="(step, index) in steps"
      :key="step.title.split(' ').join('')"
      text
      class="step-item"
      :class="{active: currentStep === (index + 1), done: currentStep > (index + 1)}"
      @click.native="updateCurrentStep(index)"
    >
      <div class="step-icon">
        <span v-if="currentStep <= (index + 1)">{{ index + 1 }}</span>
        <v-icon
          v-if="currentStep > (index + 1)"
          color="white"
        >
          mdi-check
        </v-icon>
      </div>
      <div class="step-name">
        {{ step.title }}
      </div>
    </naj-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'NajStepper',
  props: {
    steps: {
      required: true,
      validator: function (value) {
        return value.some((e) => {
          const keys = Object.keys(e);
          // eslint-disable-next-line eqeqeq
          return keys.indexOf('title') != -1;
        });
      },
    },
    currentStep: { required: false },
  },
  computed: { ...mapGetters(['isEditMode', 'isViewMode']) },
  methods: {
    updateCurrentStep (stepIndex) {
      const enabled = false;
      if (enabled && (this.isEditMode || this.isViewMode)) {
        this.$router.push(`./${+stepIndex + 1}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .stepper {
        display: flex;

        .step-item {
            margin-left: 15px;
            display: flex;

            .step-name {
                color: #dbdbdb;
                font-weight: 700;
                font-size: 14px;
            }

            .step-icon {
                width: 24px;
                height: 24px;
                border-radius: 100%;
                background-color: #dbdbdb;
                margin-left: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #FFF;
                font-weight: 700;
            }

            &.active {
                .step-name {
                    color: var(--app-primary-color);
                }

                .step-icon {
                    background-color: var(--app-primary-color);
                }
            }

            &.done {
                .step-name {
                    color: var(--app-dark-primary-color);
                }

                .step-icon {
                    background-color: var(--app-secondary-color);
                }
            }
        }
    }
</style>
